import { FunctionComponent as F } from "react";
import { TableRow, TableCell, Box } from "@mui/material";
import Telegram from "../Embed/Telegram";
import Youtube from "../Embed/YouTube";
import SoundCloud from "../Embed/SoundCloud";
import RefsTableRowCommentsBox from "./RefsTableRowCommentsBox";
import Rumble from "../Embed/Rumble";
import { IValue } from "./RefsTable";
import SpielsTable from "./SpielsTable";
import Vimeo from "../Embed/Vimeo";
import Twitter from "../Embed/Twitter";


interface IProps
{
  title: string,
  rowLength: number,
  record: IValue
}

const RefsTableRowContent: F<IProps> = (props: IProps) =>
{
  return (
    <TableRow>
      <TableCell colSpan={props.rowLength}>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ display: 'flex', flexGrow: 1 }}>
            <RefsTableRowCommentsBox refId={props.record.spiels[0].refs[0].refId}/>
          </Box>
            {(() =>
            {
              if(props.record.url.includes("https://player.vimeo.com"))
                return <Vimeo record={props.record}/>;
              else if(props.record.platform === "Telegram")
                return <Telegram record={props.record}/>;
              else if(props.record.platform === "YouTube" && props.record.url)
                return <Youtube record={props.record}/>;
              else if(props.record.platform === "Apple Podcasts")
                return <SoundCloud record={props.record}/>;
              else if(props.record.platform === "Rumble")
                return <Rumble videoId={String(props.record.mediaId)} record={props.record}/>;
              else if(props.record.platform === "Twitter")
                return <Twitter record={props.record}/>;
            })()}
        </Box>
      </TableCell>
    </TableRow>);
};

export default RefsTableRowContent;
